import React from 'react'
import { Icon, Dropdown, Menu } from 'antd'
import { useTranslation } from 'react-i18next'
import FolderCardHolder from '../styles/folderCardStyle'

// File drops are handled by the parent's single react-dropzone zone. The card
// just carries `data-folder-drop`/`data-folder-id` markers (so the drop event
// can resolve this folder) and lights up blue (.drag-over) when `dragOver` is
// set by the parent.
const FolderCard = ({ folderId, name, selected, dragOver, onClick, menuItems, image, itemsCount }) => {
  const { t } = useTranslation()

  // Stop the menu click from bubbling to the card's onClick (which opens the
  // folder) — e.g. so "Seleccionar carpeta" only toggles selection.
  const handleItemClick = (item) => (info) => {
    if (info && info.domEvent) info.domEvent.stopPropagation()
    item.onClick()
  }

  const overlay = menuItems ? (
    <Menu>
      {menuItems.map((item) => (
        <Menu.Item key={item.key} disabled={item.disabled} onClick={item.disabled ? undefined : handleItemClick(item)}>
          {item.label}
        </Menu.Item>
      ))}
    </Menu>
  ) : null

  return (
    <FolderCardHolder
      className={`${selected ? 'selected' : ''}${dragOver ? ' drag-over' : ''}`}
      onClick={onClick}
      data-folder-drop=""
      data-folder-id={folderId}
    >
      <div className="folder-info">
        {image ? (
          <img src={image} alt={name} className="folder-image" />
        ) : (
          <Icon type="folder" className="folder-icon" />
        )}
        <div className="folder-text">
          <span className="folder-name">{name}</span>
          {
            itemsCount !== null || itemsCount !== undefined && 
            <span className="folder-items">
              {itemsCount} {t('items')}
            </span>
          }
        </div>
      </div>

      {overlay && (
        <Dropdown overlay={overlay} trigger={['click']}>
          <Icon
            type="more"
            className="folder-menu"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      )}
    </FolderCardHolder>
  )
}

export default FolderCard
